// K-number validation: K + exactly 7 digits (or K123TEST for testing)
export const K_NUMBER_REGEX = /^K\d{7}$/i;
export const TEST_K_NUMBER = 'K123TEST';
export const isValidKNumber = (num) => {
  const trimmed = num?.trim().toUpperCase();
  if (trimmed === TEST_K_NUMBER) return true;
  return K_NUMBER_REGEX.test(trimmed);
};

// Reward constants
export const FREE_SUBSCRIPTION_THRESHOLD = 5;
export const BONUS_PER_REFERRAL_ABOVE_THRESHOLD = 5; // kr/month
export const SUBSCRIPTION_MONTHLY_COST = 49; // kr/month (example base subscription)

// UTM tracking values
export const HENVISNING_UTM_SOURCE = 'henvisning';

// Status labels
export const STATUS_LABELS = {
  pending: 'Afventer',
  active: 'Aktiv',
  lost: 'Tabt',
  cancelled: 'Annulleret'
};

export const STATUS_COLORS = {
  pending: 'bg-orange-100 text-orange-700 border-orange-200',
  active: 'bg-green-100 text-green-700 border-green-200',
  lost: 'bg-gray-100 text-gray-600 border-gray-200',
  cancelled: 'bg-red-100 text-red-700 border-red-200'
};